import { useEffect, useRef, useState } from 'react'
import Boton from './Boton'
import ModalListaProveedores from './ModalListaProveedores'
import ModalAltaProveedor from './ModalAltaProveedor'
import { proveedoresApi } from '../api/compras'
import { st } from '../pages/emp900/_helpers'

/**
 * Selector de proveedor con el mismo armado que el de cliente en la NV: campo
 * con autocompletado, 🔍 (o F6) para la búsqueda avanzada y "+" para dar de
 * alta un proveedor nuevo (queda solo en LGR, sin código de Presea).
 */
export default function BuscadorProveedor({ value, onChange, placeholder = 'Buscar proveedor por nombre, CUIT o código…', conAlta = true }) {
  const [q, setQ] = useState('')
  const [resultados, setResultados] = useState([])
  const [abierto, setAbierto] = useState(false)
  const [lista, setLista] = useState(false)
  const [alta, setAlta] = useState(false)
  const timer = useRef(null)
  const ref = useRef(null)

  useEffect(() => {
    const handler = (e) => { if (!ref.current?.contains(e.target)) setAbierto(false) }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  const buscar = (texto) => {
    setQ(texto)
    clearTimeout(timer.current)
    if (texto.trim().length < 2) { setResultados([]); return }
    timer.current = setTimeout(async () => {
      try {
        const { data } = await proveedoresApi.listar({ q: texto.trim(), per_page: 20 })
        setResultados(data.data || [])
        setAbierto(true)
      } catch { setResultados([]) }
    }, 300)
  }

  const elegir = (p) => { onChange(p); setAbierto(false); setLista(false); setAlta(false); setQ('') }
  const codigo = (p) => (p.codigo_presea != null ? `#${p.codigo_presea}` : 'LGR')

  return (
    <div>
      {value ? (
        <div style={st.chipTercero}>
          <span style={st.chipNombre}>{value.nombre}</span>
          <span style={st.chipDoc}>{codigo(value)}</span>
          {value.cuit && <span style={st.chipDoc}>{value.cuit}</span>}
          <button type="button" style={st.chipQuitar} onClick={() => { onChange(null); setQ('') }} aria-label="Quitar">×</button>
        </div>
      ) : (
        <div ref={ref} style={{ position: 'relative', display: 'flex', gap: 8, alignItems: 'center' }}
          onKeyDown={e => { if (e.key === 'F6') { e.preventDefault(); setLista(true) } }}>
          <input style={{ ...st.input, flex: 1 }} value={q} onChange={e => buscar(e.target.value)} onFocus={() => resultados.length && setAbierto(true)} placeholder={placeholder} />
          <Boton variante="secondary" sm type="button" style={{ flexShrink: 0 }} onClick={() => setLista(true)} title="Buscar proveedor (F6)">🔍</Boton>
          {conAlta && <Boton variante="primary" sm type="button" style={{ flexShrink: 0 }} onClick={() => setAlta(true)} title="Nuevo proveedor">+</Boton>}
          {abierto && (
            <div style={st.dropdown}>
              {resultados.length === 0 && <div style={st.ddVacio}>Sin resultados.</div>}
              {resultados.map(p => (
                <div key={p.id} style={st.ddItem} onMouseDown={() => elegir(p)}>
                  <div style={st.ddFila}><span style={st.ddNombre}>{p.nombre}</span></div>
                  <div style={st.ddMeta}>{codigo(p)} · {p.cuit || 'sin CUIT'}{p.nombre_fantasia ? ` · ${p.nombre_fantasia}` : ''}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      {!value && <span style={{ display: 'block', marginTop: 4, fontSize: '0.75rem', color: '#94a3b8' }}>F6 abre la búsqueda avanzada (por nombre, CUIT o código).</span>}
      {lista && <ModalListaProveedores onSelect={elegir} onClose={() => setLista(false)} />}
      {alta && <ModalAltaProveedor onCreado={elegir} onClose={() => setAlta(false)} />}
    </div>
  )
}
